// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2022 Ericsson and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/* Copied from https://github.com/microsoft/vscode/blob/7d9b1c37f8e5ae3772782ba3b09d827eb3fdd833/src/vs/workbench/contrib/languageStatus/browser/media/languageStatus.css */

.hover-language-status {
  display: flex;
  padding: 4px 8px;
}

.hover-language-status:not(:last-child) {
  border-bottom: 1px solid var(--theia-notifications-border);
}

.hover-language-status > .severity {
  padding-right: 8px;
  flex: 1;
  margin: auto;
  display: none;
}

.hover-language-status > .severity.sev3 {
  color: var(--theia-notificationsErrorIcon-foreground);
}

.hover-language-status > .severity.sev2 {
  color: var(--theia-notificationsInfoIcon-foreground);
}

.hover-language-status > .severity.show {
  display: inherit;
}

.hover-language-status > .element {
  display: flex;
  justify-content: space-between;
  vertical-align: middle;
  flex-grow: 100;
}

.hover-language-status > .element > .left > .detail:not(:empty)::before {
  /* en-dash */
  content: "–";
  padding: 0 4px;
  opacity: 0.6;
}

.hover-language-status > .element > .left > .label:empty {
  display: none;
}

.hover-language-status > .element .left {
  margin: auto 0;
}

.hover-language-status > .element .right {
  margin: auto 0;
  display: flex;
}

.hover-language-status > .element .right:not(:empty) {
  padding-left: 16px;
}

.hover-language-status > .element .right .language-status-link {
  margin: auto 0;
  white-space: nowrap;

  /* ADDED STYLES - NOT FROM VSCODE */
  text-decoration: none;
}

/* ADDED STYLES - NOT FROM VSCODE */
.hover-language-status > .element .right .language-status-link:hover {
  color: var(--theia-textLink-foreground);
}

.hover-language-status
  > .element
  .right
  .language-status-action-bar:not(:first-child) {
  padding-left: 8px;
}

/* ADDED STYLES - NOT FROM VSCODE */
.hover-language-status > .element .right .language-status-action-bar a {
  color: var(--theia-editorHoverWidget-foreground);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/editor/src/browser/language-status/editor-language-status.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF,2KAA2K;;AAE3K;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;;EAEnB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,uCAAuC;AACzC;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;AAClD","sourcesContent":["/********************************************************************************\n * Copyright (C) 2022 Ericsson and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n/* Copied from https://github.com/microsoft/vscode/blob/7d9b1c37f8e5ae3772782ba3b09d827eb3fdd833/src/vs/workbench/contrib/languageStatus/browser/media/languageStatus.css */\n\n.hover-language-status {\n  display: flex;\n  padding: 4px 8px;\n}\n\n.hover-language-status:not(:last-child) {\n  border-bottom: 1px solid var(--theia-notifications-border);\n}\n\n.hover-language-status > .severity {\n  padding-right: 8px;\n  flex: 1;\n  margin: auto;\n  display: none;\n}\n\n.hover-language-status > .severity.sev3 {\n  color: var(--theia-notificationsErrorIcon-foreground);\n}\n\n.hover-language-status > .severity.sev2 {\n  color: var(--theia-notificationsInfoIcon-foreground);\n}\n\n.hover-language-status > .severity.show {\n  display: inherit;\n}\n\n.hover-language-status > .element {\n  display: flex;\n  justify-content: space-between;\n  vertical-align: middle;\n  flex-grow: 100;\n}\n\n.hover-language-status > .element > .left > .detail:not(:empty)::before {\n  /* en-dash */\n  content: \"–\";\n  padding: 0 4px;\n  opacity: 0.6;\n}\n\n.hover-language-status > .element > .left > .label:empty {\n  display: none;\n}\n\n.hover-language-status > .element .left {\n  margin: auto 0;\n}\n\n.hover-language-status > .element .right {\n  margin: auto 0;\n  display: flex;\n}\n\n.hover-language-status > .element .right:not(:empty) {\n  padding-left: 16px;\n}\n\n.hover-language-status > .element .right .language-status-link {\n  margin: auto 0;\n  white-space: nowrap;\n\n  /* ADDED STYLES - NOT FROM VSCODE */\n  text-decoration: none;\n}\n\n/* ADDED STYLES - NOT FROM VSCODE */\n.hover-language-status > .element .right .language-status-link:hover {\n  color: var(--theia-textLink-foreground);\n}\n\n.hover-language-status\n  > .element\n  .right\n  .language-status-action-bar:not(:first-child) {\n  padding-left: 8px;\n}\n\n/* ADDED STYLES - NOT FROM VSCODE */\n.hover-language-status > .element .right .language-status-action-bar a {\n  color: var(--theia-editorHoverWidget-foreground);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
